export const API_V1 = '/api';
